import React from 'react';

import { images } from '../../../constants';
import { useTranslation } from "react-i18next";

import { getUrlLanguage } from '../../../utils/languageFunctions';

const Hero = () => {

    // Assign social media page according the languague of page
    let facebookURL, instagramURL, TiktokURL;

    if(getUrlLanguage() === "/es"){ // Si el lenguaje actual es español, entonces
        
        facebookURL  = "https://www.facebook.com/profile.php?id=61573039442698";
        instagramURL = "https://www.instagram.com/honkypie_espanol?igsh=MWk5Zm5oanA2ODNheA==";
        TiktokURL    = "https://www.tiktok.com/@honkypie_espanol?_t=ZM-8twR5K9WRNt&_r=1";

    }else{ // Si el lenguaje actual es inglés, entonces
                       
        facebookURL  = "https://www.facebook.com/profile.php?id=61573141527554";
        instagramURL = "https://www.instagram.com/honkypie_?igsh=eWMxMGdtZmpkYjR3";
        TiktokURL    = "https://www.tiktok.com/@honkypie_?_t=ZM-8twQv0kLoBR&_r=1";
    }


    const { t } = useTranslation();

    return (
        <section className='container mx-auto flex flex-col px-5 lg:py-4 py-7 lg:flex-row items-center'>
            <div className='lg:mt-10 mt-5 lg:w-1/2'>
                <h1 className='font-roboto text-3xl text-center font-bold text-dark-soft md:text-5xl lg:text-4xl xl:text-5xl lg:text-left lg:max-w-[540px]'>{t('About Us')}</h1>
                <p className='text-gray-900 mt-4 text-left md:text-xl lg:text-base xl:text-xl'>
                    {t('Absurd humor comic strips made with a lot of love by Pedro Jonz (Cartoonist, writer, software developer and geek by nature).')}
                </p>

                <div className='font-roboto text-center font-bold text-dark-soft text-4xl lg:text-left py-5 mt-6'>{t('Follow us on')}:</div>
 
                <div className="flex lg:justify-start justify-center text-gray-500">
                    <ul className="flex space-x-4">
                        <li>
                            <a href={facebookURL}>
                                <img className="w-20" src={images.FacebookSquareIcon} alt="" />
                            </a>
                        </li>
                        <li>
                            <a href={instagramURL}>
                                <img className="w-20" src={images.InstagramSquareIcon} alt="" />
                            </a>
                        </li>
                        <li>
                            <a href={TiktokURL}>
                                <img className="w-20" src={images.TiktokSquareIcon} alt="" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='order-first lg:order-last size-1/2 lg:size-4/6'>
                <img src={images.HeroImage} alt="users are reading articles" />
            </div>

        </section>
    )
}

export default Hero;
